"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var warning_1 = require("../utils/warning");
var Messages = require("../codegen/Messages");
var Aria_1 = require("../resources/Aria");
// SpinnerSize is not used in HgDS
var SpinnerSize;
(function (SpinnerSize) {
    /**
     * Small (20px).
     */
    SpinnerSize[SpinnerSize["Small"] = 20] = "Small";
    /**
     * Medium (30px).
     */
    SpinnerSize[SpinnerSize["Medium"] = 30] = "Medium";
    /**
     * Large (60px).
     */
    SpinnerSize[SpinnerSize["Large"] = 60] = "Large";
    /**
     * XLarge (90px).
     */
    SpinnerSize[SpinnerSize["XLarge"] = 90] = "XLarge";
    /**
     * XXLarge (120px).
     */
    SpinnerSize[SpinnerSize["XXLarge"] = 120] = "XXLarge";
})(SpinnerSize = exports.SpinnerSize || (exports.SpinnerSize = {}));
var spinnerLineCount = 10;
// This Spinner isn't publicly exported, only for use in oui-react components (non-HgDS).
exports.Spinner = function (_a) {
    var testId = _a.testId, label = _a.label, _b = _a.size, size = _b === void 0 ? SpinnerSize.Medium : _b, _c = _a.additionalClassNames, additionalClassNames = _c === void 0 ? [] : _c;
    var styleProps = {
        height: size + "px",
        width: size + "px"
    };
    var spinnerLines = [];
    for (var i = 0; i < spinnerLineCount; i++) {
        spinnerLines.push(React.createElement("div", { className: "oui-hg-spinner-line", "aria-hidden": "true", role: Aria_1.Roles.Presentation, key: i }));
    }
    return (React.createElement("div", { className: classNames("oui-hg-spinner", additionalClassNames), style: styleProps, "aria-busy": "true", "aria-label": label || Messages.Common.loading(), role: Aria_1.Roles.Alertdialog, "data-test-id": testId },
        React.createElement("div", { className: "oui-hg-spinner-box", style: __assign({}, styleProps, { transform: "scale(" + size / SpinnerSize.Medium + ") rotate(-90deg)" }), "aria-hidden": "true", role: Aria_1.Roles.Presentation }, spinnerLines)));
};
/**
 * OUI spinner component.
 *
 * @oui-component Spinner
 */
var ExternalSpinner = function (_a) {
    var ariaLabel = _a.ariaLabel, label = _a.label, testId = _a.testId, _b = _a.additionalClassNames, additionalClassNames = _b === void 0 ? [] : _b;
    warning_1.default(ariaLabel !== undefined, "`ariaLabel` is being deprecated, use `label` instead");
    return (React.createElement(exports.Spinner, { additionalClassNames: additionalClassNames, label: label, testId: testId }));
};
exports.default = ExternalSpinner;
//# sourceMappingURL=Spinner.js.map